import React from 'react';
import { mode } from '@chakra-ui/theme-tools';
import { FormControl, FormLabel, Select, Text, Flex } from '@chakra-ui/react';
import { Field, ErrorMessage } from 'formik';

const SelectField = ({
  required = false,
  disabled = false,
  label,
  name,
  options,
  onChange,
  ...rest
}) => {
  return (
    <FormControl
      mt={6}
      isRequired={required}>
      <FormLabel
        fontSize='md'
        pl='2'
        color={mode('secondaryGray.900', 'gray.200')}
        fontWeight='500'>
        {label}
      </FormLabel>
      <Flex
        alignItems='center'
        mt={-1}>
        <Field name={name}>
          {({ field, meta, form }) => (
            <Select
              {...field}
              onChange={(e) => {
                if (onChange) {
                  onChange(e, field, form);
                } else {
                  field.onChange(e);
                }
              }}
              variant={disabled ? 'authNoBorder' : 'auth'}
              disabled={disabled}
              borderColor={meta.touched && meta.error ? 'red.500' : undefined}
              {...rest}>
              {options.map((option) => (
                <option
                  key={option.value}
                  value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          )}
        </Field>
      </Flex>
      <ErrorMessage
        name={name}
        component='div'>
        {(msg) => (
          <Flex
            color='red.600'
            fontSize='sm'
            fontWeight='500'
            pl='2'
            align='center'
            gap='1'>
            <Text>{msg}</Text>
          </Flex>
        )}
      </ErrorMessage>
    </FormControl>
  );
};

export default SelectField;
